import { braucheNeuladen, kennungDerSitzung } from '~/modules/common/services/util/kontowechsel';

/**
 * Wechselt das Konto, lädt die offene Seite neu.
 *
 * Die Begründung und der gemessene Befund stehen in
 * `modules/common/services/util/kontowechsel.ts`. Hier steht nur die
 * Verdrahtung: Die Sitzung wird ohnehin beim Fensterwechsel aufgefrischt
 * (`enableRefreshOnWindowFocus` in der nuxt.config) — genau dann fällt der
 * Wechsel auf, und genau dann holt sich die Seite ihren Inhalt neu.
 */
export default defineNuxtPlugin(() => {
  const { data, status } = useAuth();
  let bekannt: string | null = null;

  watch([data, status], ([sitzung, stand]) => {
    const jetzt = kennungDerSitzung(sitzung);
    if (braucheNeuladen(bekannt, jetzt, stand as string)) {
      bekannt = jetzt;
      reloadNuxtApp({ force: true });
      return;
    }
    if (stand === 'authenticated' && jetzt) bekannt = jetzt;
  }, { immediate: true });
});
